// Theme configuration for light and dark mode
// Primary color: #2563EB is used throughout the project

export const themeColors = {
  light: {
    // Primary colors
    primary: '#2563EB',
    primaryHover: '#1D4ED8',
    primaryDark: '#1D4ED8',
    
    // Shell background behind Zavio-style sidebar (light = soft gray, dark = app bg)
    shellBackground: '#F3F4F6',
    background: '#ffffff',
    backgroundSecondary: '#f7fafd',
    backgroundTertiary: '#f8f9fa',
    
    // Text colors
    textPrimary: '#1F2937',
    textSecondary: '#475569',
    textTertiary: '#64748B',
    textLight: '#94A3B8',
    
    // Border colors
    border: '#e5e7eb',
    borderLight: '#E8EBF0',
    borderDark: '#D4DAE3',

    // Other colors — akcenty z loga Effzone
    white: '#ffffff',
    error: '#F2452D',
    warning: '#FC9D0C',
    success: '#3BA557',
    info: '#3b82f6',
  },
  
  dark: {
    // Primary colors (same as light mode)
    primary: '#2563EB',
    primaryHover: '#1D4ED8',
    primaryDark: '#1D4ED8',
    
    // Shell background behind Zavio-style sidebar
    shellBackground: '#0f172a',
    
    // Background colors
    background: '#0f172a', // slate-950
    backgroundSecondary: '#1e293b', // slate-800
    backgroundTertiary: '#334155', // slate-700
    
    // Text colors
    textPrimary: '#f1f5f9', // slate-100
    textSecondary: '#cbd5e1', // slate-300
    textTertiary: '#94a3b8', // slate-400
    textLight: '#64748b', // slate-500
    
    // Border colors
    border: '#334155', // slate-700
    borderLight: '#475569', // slate-600
    borderDark: '#1e293b', // slate-800
    
    // Other colors — akcenty z loga Effzone
    white: '#ffffff',
    error: '#F2452D',
    warning: '#FC9D0C',
    success: '#3BA557',
    info: '#3b82f6',
  }
};

/**
 * Get theme colors based on current mode
 * @param {boolean} isDarkMode - Whether dark mode is active
 * @returns {Object} Theme colors object
 */
export const getThemeColors = (isDarkMode) => {
  return isDarkMode ? themeColors.dark : themeColors.light;
};









